import { render, staticRenderFns } from "./TableDescription.vue?vue&type=template&id=060be7fb&scoped=true&"
import script from "./TableDescription.vue?vue&type=script&lang=js&"
export * from "./TableDescription.vue?vue&type=script&lang=js&"
import style0 from "./TableDescription.vue?vue&type=style&index=0&id=060be7fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060be7fb",
  null
  
)

export default component.exports